import { Helmet } from "react-helmet-async";
import AboutSection from "../components/AboutSection";

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>About Us | Nexalus Infotech</title>
        <meta
          name="description"
          content="Learn about Nexalus Infotech — our mission, experience, and commitment to ELV and ICT excellence in Ahmedabad, India."
        />
      </Helmet>
      <main className="pt-24">
        <AboutSection />
      </main>
    </>
  );
}
